import Schema from '../Schema';

const PremiumPlans = new Schema({
  _id: String,

  unique_slug: String,

  service: String,

  type: {
    first: {
      price: {
        currency: String,
        value: Number
      },
      point: Number,
      term: {
        type: Number,
        default: 90
      }
    },
    renewal: {
      price: {
        currency: String,
        value: Number
      },
      point: Number,
      term: {
        type: Number,
        default: 90
      }
    },
    recontract: {
      price: {
        currency: String,
        value: Number
      },
      point: Number,
      term: {
        type: Number,
        default: 90
      }
    }
  }
});

export default PremiumPlans;
